import React from "react"

import { Obj, connect } from "scrivito"
import { ProjectPageObjAttributes } from "scrivito/Objs/ProjectPage/ProjectPageObjClass"
import { SharedProjectPageObjAttributes } from "scrivito/Objs/SharedProjectPage/SharedProjectPageObjClass"
import { Button, ButtonProps, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProjectChatButton } from "./hooks/useProjectChatButton"

function ProjectChatButtonComponent({
  page,
  ...props
}: ButtonProps & {
  page: Obj<ProjectPageObjAttributes | SharedProjectPageObjAttributes>
}) {
  const buttonProps = useProjectChatButton({ page })

  return (
    <Button
      variant={ButtonVariant.PRIMARY}
      icon={IconName.COMMENT}
      {...buttonProps}
      {...props}
    />
  )
}

export const ProjectChatButton = React.memo(connect(ProjectChatButtonComponent))
